// This file is part of Coog. The COPYRIGHT file at the top level of
// this repository contains the full copyright notices and license terms.

export const CSS_UID = 'duplicate-6c0710df-9202-4f17-be12-5f7287995c47';
